import axios from '@/http.js';
import qs from 'qs';

export const TEMPLATE_MGT_TABLE = 'api/templates';
export const TEMPLATE_VIEW_TABLE = 'api/visit/projectDataManage';
export default {
    getTemplateById(id) {
        const url = `api/template/${id}`;
        return axios.get(url);
    },
    getTemplateListByProjectId(projectId, name) {
        let url = 'api/admin/projectTemplates';
        if (name) {
            url += `?name=${name}`;
        }
        return axios.get(url, {
            headers: {
                projectId: projectId
            }
        });
    },
    getTemplateList(param) {
        return axios.post(TEMPLATE_MGT_TABLE, param);
    },
    saveTemplate(data) {
        const url = 'api/template/save';
        return axios.post(url, data);
    },
    saveTemplatev2(data) {
        const url = 'api/template/v2/save';
        return axios.post(url, data);
    },
    updateTemplate(data, updateCover = false) {
        const url = `api/template/update`;
        data.updateCover = updateCover;
        return axios.put(url, data, {
            headers: {
                projectId: data.projectId
            }
        });
    },
    hideTemplate(projectId, idArray, showOrHide) {
        const url = 'api/template/hide';
        return axios.put(url, {
            templateIds: idArray, hide: showOrHide
        }, {
            headers: {
                projectId
            }
        });
    },
    getByGroup(tplGroupId, bgGroupId, projectId) {
        const url = `api/template/group?tplGroupId=${tplGroupId}&bgGroupId=${bgGroupId}`;
        return axios.get(url, {
            headers: {
                projectId: projectId
            }
        });
    },
    getTemplateGroupByProjectId(projectId, type) {
        const url = `api/template/list/group?type=${type}`;
        return axios.get(url, {
            headers: {
                projectId: projectId
            }
        });
    },
    deleteTemplates(idArray) {
        const url = 'api/template';
        return axios.delete(url, {data: idArray});
    },
    deleteTemplateGroup(groupName, type, projectId) {
        const url = `api/template/group`;
        return axios.delete(url, {
            params: {
                groupName: encodeURI(groupName),
                type: type
            },
            paramsSerializer: params => {
                return qs.stringify(params, {indices: false});
            },
            headers: {
                projectId: projectId
            }
        });
    },
    getNosImgUrlByNetworkImg(imgUrl) {
        const url = '/api/storage/upload/url';
        return axios.post(url, {url: imgUrl});
    },
    getTemplateTags(projectId) {
        const url = `/api/tag?type=TEMPLATE`;
        return axios.get(url, {
            headers: {
                projectId: projectId
            }
        });
    },
    getTemplateIndexTags(projectId) {
        const url = `/api/tag/filter?type=TEMPLATE`;
        return axios.get(url, {
            headers: {
                projectId: projectId
            }
        });
    },
    getTemplateCategory(projectId) {
        const url = `/api/template/category/filterList`;
        return axios.get(url, {
            params: {
                projectId: projectId
            }
        });
    },
    delTemplateTag(id) {
        const url = `/api/tag/delete?id=${id}`;
        return axios.delete(url);
    },
    getTemplateSize(projectId, param) {
        let paramStr = new URLSearchParams(param);
        const url = `api/template/list/widght?projectId=${projectId}&${paramStr}`;
        return axios.get(url, {
            headers: {projectId}
        });
    },
    setTemplateGroupTag(projectId, params) {
        const url = `/api/tag/batchSet/template`;
        return axios.put(url, params, {
            headers: {projectId}
        });
    },
    setTplCategory(projectId, params) {
        const url = `/api/admin/template/setCategory`;
        return axios.put(url, params, {
            headers: { projectId }
        });
    },
    setOneTemplateGroupTag(projectId, params) {
        const url = `/api/tag/single/template`;
        return axios.put(url, params, {
            headers: {projectId}
        });
    },
    getTemplateGroupByTemplateId(templateId) {
        const url = `api/template/${templateId}/multi`;
        return axios.get(url, {
            headers: {}
        });
    },
    sortTemplates(params) {
        const url = `/api/template/sort`;
        return axios.put(url, params);
    },
    saveTemplateWord(params) {
        const url = '/api/material/html/save';
        return axios.post(url, params, {
            headers: {
                projectId: params.projectId,
                templateId: params.templateId
            }
        });
    },
    deleteTemplateWord(ids, projectId) {
        const url = '/api/material/html/delete';
        return axios.delete(url, {
            data: ids, headers: {
                projectId: projectId
            }
        });
    },
    getTemplateWordList(params) {
        const url = '/api/material/html/query';
        return axios.post(url, params, {
            headers: {
                projectId: params.projectId
            }
        });
    },
    copyTemplates(data) {
        const url = '/api/admin/copyTemplates';
        return axios.post(url, data, {
            headers: {
                projectId: data.projectId
            }
        });
    },
    copyTemplateGroup(groupIds, templateIds, type) {
        const url = 'api/admin/copyPsdGroup';
        return axios.post(url, {
            psdGroupIds: groupIds,
            targetTemplateIds: templateIds,
            type
        });
    },
    getTemplateView(params) {
        return axios.get(TEMPLATE_VIEW_TABLE, {
            headers: {
                projectId: params.projectId
            }
        });
    },
    sortTemplateGroup(projectId, tplGroupId, sortNum) {
        let url = `api/sortTplGroup?sortNum=${sortNum}&tplGroupId=${tplGroupId}`;
        return axios.put(url, null, {
            headers: {
                projectId
            }
        });
    },
    getTemplateCount() {
        let url = `/api/template/count`;
        return axios.get(url);
    },
    getGroupTemplateById(id) {
        let url = `api/template/findGroupTemplatesById?id=${id}`;
        return axios.get(url);
    },
    copyToTemplateFree(id) {
        let url = `api/template/convertFree/${id}`;
        return axios.put(url);
    },
    copyToTemplateFreeByProjectId(projectId) {
        let url = `api/template/convertAllToFree`;
        return axios.put(url, null,{
            headers: {projectId}
        });
    },
    checkPermissionByTemplateId(id) {
        let url = `api/publicTemplateInfo/${id}`;
        return axios.get(url);
    },
    getDeptWorksCount () {
        return axios.get(`/api/deptWorkStats/current`)
    }
}